<template>
    <page>
        <module>
            <view-list ref="view" :work-type="workType" :view-config="saasInfo.viewmanage">
                <template #search>
                    <m-search ref="search">
                        <m-search-item label="通联会员ID">
                            <c-input name="biz_userid"></c-input>
                        </m-search-item>
                        <m-search-item label="关联用户">
                            <c-input name="user_realname"></c-input>
                        </m-search-item>
                        <m-search-item label="手机号">
                            <c-input name="phone"></c-input>
                        </m-search-item>
                        <m-search-item label="银行卡号">
                            <c-input name="bank_card_no"></c-input>
                        </m-search-item>
                    </m-search>
                </template>

                <template #operate>
                    <c-button v-if="auth('b_purchase_supplier_export')"
                              prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出
                    </c-button>
                </template>

                <!--银行卡/账户属性 0:个人银行卡 1:企业对公账户-->
                <template #bank_card_pro="{data}">
                    <c-state tag dict="bankCardProDic" :value="data.bank_card_pro"></c-state>
                </template>
                <!--绑卡状态-->
                <template #bind_state="{data}">
                    <c-state tag dict="cardBindStateDic" :value="data.bind_state"></c-state>
                </template>

                <c-table-column
                        type="button"
                        label="操作"
                        width="110"
                        button-limit="6"
                >
                    <template #default="{data}">
                        <c-table-button v-if="auth('b_account_bankcard_unbind')" icon="tf-unbind" @click="unbindBankcard(data)" :disabled="data.bind_state != 1">解绑</c-table-button>
                    </template>
                </c-table-column>
            </view-list>
        </module>
    </page>
</template>

<script>
import {mapState} from 'vuex'

export default {
    name:'m_account_bankcard',
    components: {
    },

    data() {
        return {
            workType: 32
        }
    },

    computed: {
        // 获取dictName选项数据
        ...mapState(['saasInfo', 'bankCardProDic', 'cardBindStateDic'])
    },

    methods: {
        unbindBankcard(data) {
            this.$confirm({
                message:'确认解绑银行卡【' + data.bank_name + '/ '+data.bank_card_no+'】？',  // 提示内容,
                buttonName: '确定',  // 确定按钮文字
                cancelButton: true,  // 是否显示取消按钮
                resolve: () => {
                    this.request({
                        url: '/allinpay/unbind/bankcard',
                        data: {
                            id: data.id
                        },
                        loading: true,
                        success: data => {
                            //刷新
                            this.$refs.view.update();

                            this.$message({
                                message: '解绑成功',  // 提示内容,
                                type:'success'
                            });
                        }
                    });
                },  // 确定按钮回调
                cancel: () => {},  // 取消按钮回调
            });
        }
    }
}
</script>

<style lang="stylus" scoped>
</style>